import { inject, Injectable } from '@angular/core';
import { PublicUserDataModel } from '@appTypes/chat-api.types';
import { Store } from '@ngxs/store';
import {
  chatGetUnseenMessagesCount,
  chatInit,
  chatUpdateConversation,
  chatUpsertMessages
} from '../state/chat.actions';
import { ChatWsActionsService } from './chat-ws-actions.service';
import { ChatWsService } from './chat-ws.service';

@Injectable({
  providedIn: 'root'
})
export class ChatWsListenersService {
  readonly #chatWsService = inject(ChatWsService);
  readonly #chatWsActionsService = inject(ChatWsActionsService);
  readonly #store = inject(Store);
  init() {
    this.#onNewConversation();
    this.#onNewMessage();
    this.#onUpdateConversation();
    this.#onWhoami();
  }

  #onNewConversation() {
    this.#chatWsService.io.on('newConversation', (conversation) => {
      if (conversation?._id)
        this.#chatWsActionsService.getConversation(conversation._id).subscribe((conversationDetails) => {
          this.#store.dispatch(new chatUpdateConversation([conversationDetails]));
          this.#store.dispatch(new chatGetUnseenMessagesCount());
        });
    });
  }
  #onWhoami() {
    this.#chatWsService.io.on('whoami', (data: PublicUserDataModel) => {
      if (!data?.id) {
        this.#chatWsService.io.disconnect();
        throw new Error('WebSocket authentication failed: User data is missing');
      }
      if (this.#chatWsService.io.id) this.#store.dispatch(new chatInit(this.#chatWsService.io.id, data));
    });
  }

  #onNewMessage() {
    this.#chatWsService.io.on('newMessage', (message) => {
      this.#store.dispatch(new chatUpsertMessages([message]));
      this.#store.dispatch(new chatGetUnseenMessagesCount());
    });
  }

  #onUpdateConversation() {
    this.#chatWsService.io.on('updateConversation', (conversation) => {
      if (conversation?._id)
        this.#chatWsActionsService.getConversation(conversation._id).subscribe((conversationDetails) => {
          this.#store.dispatch(new chatUpdateConversation([conversationDetails]));
          this.#store.dispatch(new chatGetUnseenMessagesCount());
        });
    });
  }
}
